import React from 'react';

import "../styles/End.css";

let isIE = /*@cc_on!@*/false || !!document.documentMode;

var End = () => (
  <div className="end">
    <img className="header" src={require("../assets/header-footer-colours.jpg")} alt="Header" /> 
    <h1 className="pageTitle">Finished!</h1>
    <div className="bbbLogo" >
      <img className="" src={require("../assets/power-quiz-logo.png")} alt="Power Quiz Logo" />
    </div>
    <img className="asLogo" src={require("../assets/ageScotlandLogo.png")} alt="ageScotland Logo" />  
    <img className="footer" src={require("../assets/header-footer-colours.jpg")} alt="Footer" /> 
  </div>
);

if(isIE){
  End = () => (
    <div className="ie-end">
    <div className="header-footer">
      <img className="header" src={require("../assets/header-footer-colours.jpg")} alt="Header" />
    </div>
    <div className="pageContent">
      <div className="logos"> 
        <div className="col-4"></div>
        <div className="col-4">
          <img className="bbbLogo" src={require("../assets/power-quiz-logo.png")} alt="Power Quiz Logo" />
        </div>
        <div className="col-4">
          <img className="asLogo" src={require("../assets/ageScotlandLogo.png")} alt="ageScotland Logo" />
        </div>
      </div>   
      <div className="under-logos">
        <div className="col-4"></div>
        <div className="col-4 c">
          <h1 className="pageTitle">Finished!</h1>
        </div>
        <div className="col-4"></div>
      </div>
    </div>  
    <div className="header-footer">
      <img className="footer" src={require("../assets/header-footer-colours.jpg")} alt="Header" />
    </div>
  </div>
  );
} 

export default End;
